import React from 'react';

import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';

interface IWithdrawPlayerModalProps {
  modalIsOpen: boolean;
  onPlayerWithdraw: () => Promise<void>;
  cancelPlayerWithdraw: () => void;
}

export const WithdrawPlayerModal: React.FunctionComponent<IWithdrawPlayerModalProps> = props => {
  const { modalIsOpen, onPlayerWithdraw, cancelPlayerWithdraw } = props;

  return (
    <Modal
      onClose={cancelPlayerWithdraw}
      open={modalIsOpen}
      className="round-launch-confirm-modal staff-scope"
      id="round-launched-modal"
      title="ARE YOU SURE?"
      wideButton={true}
      actions={[
        <Button
          key="cancel-round-launch"
          onClick={onPlayerWithdraw}
          variant="outlined"
          color="primary"
          fullWidth={true}
        >
          YES, WITHDRAW
        </Button>,
        <Button
          key="confirm-round-launch"
          fullWidth={true}
          onClick={cancelPlayerWithdraw}
          variant="contained"
          className="confirm-removal-button"
          color="primary"
        >
          NO, DO NOT WITHDRAW
        </Button>
      ]}
    >
      <p>
        If a player is withdrawn that player will be disqualified and not able to be entered back
        into the event.
      </p>
    </Modal>
  );
};
